import { RootState } from '../../RootState';
import { SessionStateContent } from '../SessionState';

const selectOptionalSessionContent = (state: RootState): SessionStateContent | null => {
  return state.session.content;
};

export default selectOptionalSessionContent;
